// Action creators extracted from ResourceBankModule.js

import {
  INITIALISE_RESOURCEBANK_COMPONENT,
  UPDATE_RESOURCEBANK_FILTERS,
  TOGGLE_RESOURCEBANK_FILTER_ITEM,
  TOGGLE_ALL_RESOURCEBANK_FILTER_ITEMS,
  TOGGLE_RESOURCEBANK_SELECTED_RESOURCES,
  CLEAR_RESOURCEBANK_SELECTED_RESOURCES,
} from "./ResourceBankConstants";

// Action Creators

export const initaliseResourceBankComponent = id => {
  return {
    type: INITIALISE_RESOURCEBANK_COMPONENT,
    data: id,
  };
};

export const updateResourceBankFilters = (params, id) => {
  return {
    type: UPDATE_RESOURCEBANK_FILTERS,
    data: { params, id },
  };
};

export const toggleResourceBankFilterItem = (params, id) => {
  return {
    type: TOGGLE_RESOURCEBANK_FILTER_ITEM,
    data: { params, id },
  };
};

export const toggleAllResourceBankFilterItems = (params, id) => {
  return {
    type: TOGGLE_ALL_RESOURCEBANK_FILTER_ITEMS,
    data: { params, id },
  };
};

export const toggleResourceBankSelectedResources = (params, id) => {
  return {
    type: TOGGLE_RESOURCEBANK_SELECTED_RESOURCES,
    data: { params, id },
  };
};

export const clearResourceBankSelectedResources = id => {
  return {
    type: CLEAR_RESOURCEBANK_SELECTED_RESOURCES,
    data: { id },
  };
};
